import { z } from 'zod';
import { isRealDate, uuidSchema } from './common.js';
export const REPORT_NAMES = [
    'strength',
    'attendance',
    'fee-collection',
    'fee-summary',
    'admissions',
    'staff',
];
const isoDate = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Use YYYY-MM-DD')
    .refine(isRealDate, 'Invalid calendar date');
/** The most days a date-range report may cover. */
export const MAX_REPORT_RANGE_DAYS = 366;
export const reportQuerySchema = z
    .object({
    academicYearId: uuidSchema.optional(),
    classId: uuidSchema.optional(),
    from: isoDate.optional(),
    to: isoDate.optional(),
    groupBy: z.enum(['day', 'month']).default('day'),
    format: z.enum(['json', 'csv']).default('json'),
})
    .refine((v) => !v.from || !v.to || v.from <= v.to, {
    message: 'The start date is after the end date',
    path: ['from'],
})
    .refine((v) => !v.from ||
    !v.to ||
    Date.parse(v.to) - Date.parse(v.from) <= MAX_REPORT_RANGE_DAYS * 86_400_000, {
    message: `A report can cover at most ${MAX_REPORT_RANGE_DAYS} days`,
    path: ['to'],
});
export const searchQuerySchema = z.object({
    q: z
        .string()
        .trim()
        .min(2, 'Type at least 2 characters')
        .max(100)
        .refine((v) => !v.includes('\u0000'), 'Invalid character'),
    limit: z.coerce.number().int().min(1).max(10).default(5),
});
//# sourceMappingURL=reports.js.map